import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { selectors } from 'mage-core';
// eslint-disable-next-line import/no-extraneous-dependencies
import { constants } from '@klarna/bubble-ui';
import { withHoverProps, withStyleSheetOverride } from '@klarna/higher-order-components';
const { Fonts } = constants;

const getDefaultStyleSheet = ({ designVersion, hover }) => {
  const backgroundColor = '#EB6F93';
  const hoverBackgroundColor = '#E16A8E';

  return {
    link: {
      ...Fonts.KLARNA_SANS_REGULAR,
      height: 60,
      borderRadius: 2,
      color: '#FFFFFF',
      padding: '5px 26px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      background: hover ? hoverBackgroundColor : backgroundColor,
      width: '100%',
    },
  };
};

const getObjectUrl = ({ data, type }) => {
  return window.URL.createObjectURL(new window.Blob([data], { type }));
};

export class DownloadLocalDataLink extends React.Component {
  static propTypes = {
    data: PropTypes.any.isRequired,
    filename: PropTypes.string.isRequired,
    type: PropTypes.string,
  };

  static defaultProps = {
    type: 'text/plain',
  };

  constructor(props) {
    super(props);

    this.state = {
      hover: false,
      objectUrl: getObjectUrl(props),
      data: props.data,
      type: props.type,
      isMounted: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.isMounted) {
      if (prevState.data !== nextProps.data || prevState.type !== nextProps.type) {
        window.URL.revokeObjectURL(prevState.objectUrl);
        return {
          objectUrl: getObjectUrl(nextProps.data),
        };
      }
    }
    return null;
  }

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  componentWillUnmount() {
    window.URL.revokeObjectURL(this.state.objectUrl);
    this.setState({ isMounted: false });
  }

  render() {
    // disabled eslint since all props that are not declared in proptypes have default values
    const {
      styleSheet, // eslint-disable-line react/prop-types
      filename,
      type,
      children, // eslint-disable-line react/prop-types
      onMouseOver, // eslint-disable-line react/prop-types
      onMouseOut, // eslint-disable-line react/prop-types
    } = this.props;

    return (
      <a
        style={styleSheet.link} // eslint-disable-line react/prop-types
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        href={this.state.objectUrl}
        download={filename}
        type={type}
      >
        {children}
      </a>
    );
  }
}

export default compose(
  connect(state => ({
    designVersion: selectors.getDesignVersion(state),
  })),
  withHoverProps({ hover: true }),
  withStyleSheetOverride(getDefaultStyleSheet),
)(DownloadLocalDataLink);
